import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Link} from 'react-router-dom';
import {Pagination, Loader} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import {ISOToDisplayDate} from 'common/utils';
import {PANEL_STATUS_CHANGE_DISPLAY} from 'app-ui-componentlibrary/dist/common/constants';
import {Alert} from 'componentLibrary';
import _ from 'lodash';
import {compileContent} from 'common/utils';

const DEFAULT_PAGE_SIZE = 20;

export class ReviewerHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      activePage: 1,
      firstResult: 0,
      pageSize: DEFAULT_PAGE_SIZE,
      error: false,
      loading: false,
      numEntities: 0,
      totalPages: 0,
    };
  }

  getTaskHistory = () => {
    const {token, reviewerId, sessionId} = this.props;
    const {firstResult, pageSize} = this.state;
    const variables = [
      'category',
      'entityId',
      'organizationName',
      'status',
      'endTime',
      'entityDisplay',
      'sessionId',
    ];
    const processDefinitionKey = 'panelReview';
    this.setState({
      loading: true,
    });
    return REST.workflow
      .getHistoricTasks(
        token,
        reviewerId,
        firstResult,
        pageSize,
        variables,
        processDefinitionKey,
        sessionId
      )
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(res) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          this.setState({
            entities: [...res],
            error: false,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  getTaskHistoryCount = () => {
    const {token, reviewerId, sessionId} = this.props;
    const {firstResult, pageSize} = this.state;
    const variables = [
      'category',
      'entityId',
      'organizationName',
      'status',
      'endTime',
      'entityDisplay',
      'sessionId',
    ];
    const processDefinitionKey = 'panelReview';
    this.setState({
      loading: true,
    });
    return REST.workflow
      .getHistoricTasksCount(
        token,
        reviewerId,
        firstResult,
        pageSize,
        variables,
        processDefinitionKey,
        sessionId
      )
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(res) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          this.setState({
            taskCount: res.count,
            error: false,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  handlePageChange = (activePage) => {
    const {pageSize} = this.state;
    const firstResult = pageSize * (activePage - 1);
    this.setState(
      {
        activePage,
        firstResult,
        results: undefined,
        taskCount: undefined,
      },
      () => {
        this.getTaskHistory();
        this.getTaskHistoryCount();
      }
    );
  };

  componentDidMount() {
    this.getTaskHistory();
    this.getTaskHistoryCount();
  }

  mapStatus(entityStatus) {
    return _.get(PANEL_STATUS_CHANGE_DISPLAY, entityStatus);
  }

  render() {
    const {aliases, sessionId, linkTemplate} = this.props;
    const {entities, error, activePage, loading, pageSize, taskCount} = this.state;
    const org = _.get(_.find(aliases, {value: 'organization'}), 'label');
    const id = _.get(_.find(aliases, {value: 'id'}), 'label');
    const category = _.get(_.find(aliases, {value: 'category'}), 'label');
    const dateTimeConfig = {showDate: true, showHours: true, showTimeZone: true};
    const curEntityType = _.get(_.find(aliases, {value: 'entityType'}), 'label');
    if (loading)
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    return (
      <React.Fragment>
        {error || _.isEmpty(entities) ? (
          <Alert
            type="info"
            header="Reviewer history"
            content={'No ' + curEntityType + 's found at this time.'}
            size="strong"
          />
        ) : (
          <React.Fragment>
            <FemaGoTable summary="Reviewer history table">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Date and time</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>{org}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>{id}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>{category}</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {_.map(entities, (entity) => {
                  let link = compileContent(linkTemplate, {
                    sessionId: sessionId,
                    entityId: entity.entityId,
                  });
                  return (
                    <FemaGoTable.Row>
                      <FemaGoTable.TextCell>
                        {ISOToDisplayDate(_.get(entity, 'endTime'), dateTimeConfig)}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(entity, 'organizationName')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        <Link to={link}>{_.get(entity, 'entityDisplay')}</Link>
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {_.get(entity, 'category')}
                      </FemaGoTable.TextCell>
                      <FemaGoTable.TextCell>
                        {this.mapStatus(_.get(entity, 'status'))}
                      </FemaGoTable.TextCell>
                    </FemaGoTable.Row>
                  );
                })}
              </FemaGoTable.Body>
            </FemaGoTable>
            <Pagination
              totalPages={Math.ceil(taskCount / pageSize)}
              activePage={activePage}
              onPageChange={(e, data) => this.handlePageChange(data.activePage)}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              boundaryRange={1}
              ellipsisItem={null}
            ></Pagination>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ReviewerHistory);
